import { Table } from '@tanstack/react-table'
import { ProductTable } from '.'
import { utils, writeFile } from 'xlsx'
import { Product } from '@/types/Product'
  
export const useProductSpreadsheets = () => {
    const getTableRows = (table: Table<ProductTable>): Partial<Product>[] =>
        table.getCoreRowModel().rows.map((row) => {
            const obj = {} as Record<string, any>
 
            obj['Cod. Produto'] = row.original.SK_PRODUTO
            obj['Produto'] = row.original.DS_PRODUTO
            obj['Embalagem'] = row.original.DD_SKU
            obj['Uni. Venda'] = row.original.DD_UNIDADE_VENDA
            obj['Marca'] = row.original.DD_MARCA
            obj['Fabricante'] = row.original.DS_DETENTOR
            obj['Cadastro'] = row.original.DD_ORIGEM_DADO
 
            return obj
        })

    const onDownload = (tableInstance: Table<ProductTable>) => {
         
        const rows = getTableRows(tableInstance)
        const worksheet = utils.json_to_sheet(rows)
        const workbook = utils.book_new()

        utils.book_append_sheet(workbook, worksheet, 'Produtos')

        const currentDate = new Date();
        const day = currentDate.getDate().toString().padStart(2, '0');
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const year = currentDate.getFullYear().toString();
        const currentDateFormated =  day + month + year;

        writeFile(workbook, `Produto_${currentDateFormated}.xlsx`, {
            compression: true,
        })
    }

    return {
        onDownload,
    }
}
